import { Plot } from '@/components/charts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { TopRecommendedProduct } from '@/hooks/api/useForwardsAnalytics';

import { baseLayout, blueGradient } from './chart-config';

interface Props {
  data: TopRecommendedProduct[];
}

export function TopRecommendedProductsChart({ data }: Props) {
  const top = data.slice(0, 10);
  const labels = top.map((d) => {
    const full = `${d.carrierName} - ${d.productName}`;
    return full.length > 30 ? full.slice(0, 27) + '...' : full;
  });

  if (top.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-sm">Top Recommended Products</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="py-8 text-center text-sm text-muted-foreground">
            No forwarded recommendations yet
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Top Recommended Products</CardTitle>
      </CardHeader>
      <CardContent>
        <Plot
          data={[
            {
              type: 'bar',
              orientation: 'h' as const,
              y: labels,
              x: top.map((d) => d.count),
              marker: {
                color: blueGradient(top.length),
                line: { width: 0 },
              },
              text: top.map((d) => `${d.avgRecommendationScore.toFixed(0)}`),
              textposition: 'inside' as const,
              textfont: { color: '#ffffff', size: 11 },
              insidetextanchor: 'end' as const,
              hovertemplate: top.map(
                (d) =>
                  `${d.carrierName} - ${d.productName}<br>` +
                  `Type: ${d.productType || 'N/A'}<br>` +
                  `Count: %{x}<br>` +
                  `Avg Score: ${d.avgRecommendationScore.toFixed(1)}<extra></extra>`
              ),
            },
          ]}
          layout={baseLayout({
            margin: { l: 220, r: 20, t: 10, b: 40 },
            xaxis: {
              title: { text: 'Times Recommended' },
              gridcolor: 'rgba(148,163,184,0.15)',
            },
            yaxis: {
              autorange: 'reversed',
              gridcolor: 'rgba(148,163,184,0.15)',
              ticksuffix: '  ',
            },
            barcornerradius: 4,
          })}
          config={{ displayModeBar: false, responsive: true }}
          useResizeHandler
          className="h-80 w-full"
        />
      </CardContent>
    </Card>
  );
}
